export const CONTENT_CONSTANTS = {
  ALL: "ALL",
  LANG: "lang",
  PUBLISHED: "PUBLISHED",
  DRAFT: "DRAFT",
  UNPUBLISHED: "UNPUBLISHED",
  QUIZ: "Quiz",
  QUESTION: "Question",
  POLL: "Poll",
  EVENT: "Event",
  PREVIEW_PATH: "/content/preview",
};

export const ROW_SIZE = 20;
